import { ChartConfiguration } from "@/components/ui/Chart/chart.types";

export const baseChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 50,
    animation: false,
    locale: "en-US", // number formatting
} satisfies ChartConfiguration["options"];
